<template>
	<v-list dense rounded v-if="data">
		<v-list-item>
			<v-list-item-content>
				<v-text-field
					:rules="[(v) => !!v || 'Title is mandatory']"
					required
					v-model="data.title"
					label="Title"
					filled
					prepend-icon="mdi-label-outline"
				/>
			</v-list-item-content>
		</v-list-item>
		<v-list-item>
			<v-list-item-content>
				<v-text-field
					:rules="[(v) => !!v || 'Address is mandatory']"
					class="fullwidth"
					filled
					label="Address (URL)"
					prepend-icon="mdi-link"
					required
					v-model="data.url"
				></v-text-field>
			</v-list-item-content>
		</v-list-item>
	</v-list>
</template>

<script>
export default {
	name: 'NewsForm',
	props: ['data'],
}
</script>
